import React, { useState, useRef } from "react";
import HttpService from "../../services/HttpService";
import UserService from "../../services/UserService";

function AbonnementCollapsibleKlantDashboard(props) {
  const [isOpen, setIsOpen] = useState(false);
  let abonnement = props.abonnement;
  const [interfaces, setInterfaces] = useState(abonnement.interfaces);
  const [loading, setLoading] = useState(false);
  const [selectedInterface, setSelectedInterface] = useState(null);
  let error="";
  let changeData = props.changeData;
  let resetData = props.resetData;
  let changeDataAbo = props.changeDataAbo;
  let selectedMonth = props.month;
  let selectedYear = props.year;
  let showInactive = props.showInactive;
  let triggerKey = props.triggerKey;
  let previousTriggerKey = useRef(null);

  // if the active interface status has changed, refetch the interfaces
  if(triggerKey && triggerKey !== previousTriggerKey.current){
    previousTriggerKey.current = triggerKey;
    getInterfaces();
  }

  function getTotalBerichten(maandaantallen) {
    if (selectedYear != null && selectedYear > 0) {
      maandaantallen = maandaantallen.filter((ma) => ma.jaar == selectedYear);
    }

    let total = 0;
    for (let i = 0; i < maandaantallen.length; i++) {
      total += maandaantallen[i].aantal;
    }
    return total;
  }

  function GetTotalBerichten() {
    let total = 0;
    let berichtenPerMaand = abonnement.berichtenPerMaand;
      for (let ma = 0; ma < berichtenPerMaand.length; ma++) {
        if (selectedMonth > 0) {
          if (
            selectedMonth == berichtenPerMaand[ma].maand &&
            berichtenPerMaand[ma].jaar == selectedYear
          ) {
            total += berichtenPerMaand[ma].aantal;
          }
        } else if (selectedYear > 0) {
          if (berichtenPerMaand[ma].jaar == selectedYear) {
            total += berichtenPerMaand[ma].aantal;
          }
        } else {
          total += berichtenPerMaand[ma].aantal;
        }
      }
    return total;
  }

  function getInterfaces(){
    let axios = HttpService.getAxiosClient();
    let debiNr = UserService.getDebiNr();
    if (debiNr != null) {
      let url = process.env.REACT_APP_API_URL + `/Statistieken?aboId=` + abonnement.id;
      error="";
      setLoading(true);
      axios
        .get(url)
        .then((response) => {
          console.log(response.data.interfaces);
          
          let interfaces = response.data.interfaces;
          if(!showInactive){
            interfaces = interfaces.filter((intf) => intf.status === "Actief");
            abonnement.interfaceCount = interfaces.length;
          }
          setInterfaces(interfaces);
          setLoading(false);
        })
        .catch((error) => {
          error = error.message;
          setLoading(false);
        });
    }
  }

  function AboOnclick() {
    if (!isOpen) {
      getInterfaces();
      changeDataAbo(abonnement);
      setSelectedInterface(null);
    } else {
      resetData();
    }
    setIsOpen(!isOpen);
  }

  return (
    <tbody className="border-2 border-black justify-items-center">
      <tr className="border-1 border-black" onClick={() => AboOnclick()} style={{cursor:'pointer'}}>
        <td>{abonnement.naam}</td>
        {abonnement.startdatum ? (
          <td>{abonnement.startdatum.toString().split("T")[0]}</td>
        ) : (
          <td />
        )}
        {abonnement.einddatum ? (
          <td>{abonnement.einddatum.toString().split("T")[0]}</td>
        ) : (
          <td />
        )}
        <td>{abonnement.status}</td>
        {/*change to the current amount of interfaces*/}
        <td>{abonnement.interfaceCount}</td>
        <td>{GetTotalBerichten()}</td>
      </tr>
      {isOpen && interfaces.length > 0 && (
        <tr class="bg-blue-200">
          <td class="font-semibold ">Naam</td>
          <td class="font-semibold ">Verzender</td>
          <td class="font-semibold ">Ontvanger</td>
          <td class="font-semibold ">Status</td>
          <td class="font-semibold ">Startdatum</td>
          <td class="font-semibold ">Einddatum</td>
          <td class="font-semibold ">Aantal berichten</td>
        </tr>
      )}
      {isOpen &&
      !loading &&
        interfaces.length > 0 &&
        interfaces.map((interfaceObj) => (
          <tr
            className={`border-black border ${selectedInterface === interfaceObj.id ? "bg-blue-400" : "bg-blue-200"}`}
            onClick={() => {
              changeData(interfaceObj)
              setSelectedInterface(interfaceObj.id)
            }}
            style={{cursor:'pointer'}}
          >
            <td>{interfaceObj.omschrijving}</td>
            {/*interfaceObj.verzenderNaam == "Stichting SCSN" && interfaceObj.scsnNaamVerzender!=null? (
              <td>{interfaceObj.scsnNaamVerzender}</td>
            ) : (
              <td>{interfaceObj.verzenderNaam}</td>
            )*/}
            <td>{interfaceObj.verzenderNaam}</td>
            {/*interfaceObj.ontvangerNaam == "Stichting SCSN" && interfaceObj.scsnNaamOntvanger!=null? (
              <td>{interfaceObj.scsnNaamOntvanger}</td>
            ) : (
              <td>{interfaceObj.ontvangerNaam}</td>
            )*/}
            <td>{interfaceObj.ontvangerNaam}</td>
            <td>{interfaceObj.status}</td>
            {interfaceObj.startdatum ? (
              <td>{interfaceObj.startdatum.toString().split("T")[0]}</td>
            ) : (
              <td />
            )}
            {interfaceObj.einddatum ? (
              <td>{interfaceObj.einddatum.toString().split("T")[0]}</td>
            ) : (
              <td />
            )}
            <td>
              {selectedMonth
                ? interfaceObj.berichtenPerMaand.find(
                    (ma) => ma.jaar == selectedYear && ma.maand == selectedMonth
                  ) != null
                  ? interfaceObj.berichtenPerMaand.find(
                      (ma) =>
                        ma.jaar == selectedYear && ma.maand == selectedMonth
                    ).aantal
                  : 0
                : getTotalBerichten(interfaceObj.berichtenPerMaand)}
            </td>
          </tr>
        ))}
      {isOpen && !loading && interfaces.length < 1 && <div>-</div>}
      {isOpen && loading && <div>loading</div>}
      {isOpen && !loading && error !="" && <div>loading</div>}
    </tbody>
  );
}
export default AbonnementCollapsibleKlantDashboard;
